export default __webpack_public_path__ + "static/Chateau-Ducru-Beaucaillou-4f3e29f698bb979201ef33eb1a3c3639.jpg";